"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.getCategories = exports.buildSearchCategories = void 0;
var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reduce"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _sort = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/sort"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var _entries = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/entries"));
var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));
var _slice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/slice"));
var _values = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/values"));
var _splice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/splice"));
var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/index-of"));
var _string = require("@raywhite/helpers-utils/lib/helpers/string");
var _helpers = require("./helpers");
var _codes = require("../listing/codes");
var getCategories = (typeKey, typeCode, subTypeCode, statusCode) => {
  var _context, _context2, _context3;
  if (!typeKey) return [];
  var typeMap = (0, _helpers.mapMetaTypeCodes)(typeCode, subTypeCode);
  var merged = (0, _reduce.default)(_context = (0, _keys.default)(typeMap)).call(_context, (res, code) => {
    var nextType = typeKey[code];
    if (!nextType) return res;
    var next = nextType.statusCode[statusCode] ? nextType.statusCode[statusCode].categories : undefined;
    if (!next || !next.length) return res;
    return (0, _concat.default)(res).call(res, next);
  }, []);

  // Merging can create duplicates, so drop those
  var seen = {};
  return (0, _sort.default)(_context2 = (0, _map.default)(_context3 = (0, _filter.default)(merged).call(merged, _ref => {
    var {
      code
    } = _ref;
    if (seen[code]) return false;
    seen[code] = true;
    return true;
  })).call(_context3, _ref2 => {
    var {
      code: value,
      name: label
    } = _ref2;
    return {
      label,
      value
    };
  })).call(_context2, (a, b) => {
    if (a.label === b.label) return 0;
    return a.label < b.label ? -1 : 1;
  });
};
exports.getCategories = getCategories;
var sortPrioritisedType = prioritised => (a, b) => {
  // Prioritise current listings
  var aCurrent = a.statusCode === 'CUR';
  var bCurrent = b.statusCode === 'CUR';
  var aPrioritised = prioritised[a.typeKey];
  var bPrioritised = prioritised[b.typeKey];
  var bothCurrent = aCurrent && bCurrent;
  var bothNotCurrent = !aCurrent && !bCurrent;

  // Allow priorities to override other considerations when current status matches
  if (bothCurrent || bothNotCurrent) {
    if (aPrioritised && !bPrioritised) return -1;
    if (bPrioritised && !aPrioritised) return 1;
  }
  if (bothCurrent) {
    var diff = b.total - a.total;
    if (diff !== 0) return diff;
    // Prioritise sale listings over not sale ones if all else matches
    var aSale = a.subTypeCode === 'SAL';
    var bSale = b.subTypeCode === 'SAL';
    if (aSale) return -1;
    if (bSale) return 1;
    return diff;
  }
  if (bothNotCurrent) return b.total - a.total;

  // Sort the current one before the not current one
  return aCurrent ? -1 : 1;
};
var formatLabel = (statusCode, typeCode, subTypeCode) => (subTypeCode && (0, _codes.describeSubTypeStatus)(subTypeCode, statusCode) || (0, _codes.describeTypeStatus)(typeCode, statusCode) || (0, _codes.describeStatus)(statusCode) || (0, _codes.describeTypeNouns)(typeCode, true) || 'Properties').replace(/^([a-z])/, l => l.toUpperCase());

// Filter to exclude total, we probably should have had a different data structure...
var notTotalEntry = _ref3 => {
  var [x] = _ref3;
  return x !== 'total';
};

// Extract a set of suburbs and postcodes into a single list
var extractSuburbs = suburbs => {
  var _context4;
  var entries = (0, _filter.default)(_context4 = (0, _entries.default)(suburbs)).call(_context4, notTotalEntry);
  var extracted = (0, _reduce.default)(entries).call(entries, (acc, _ref4) => {
    var _context5, _context6;
    var [name, {
      postCode: postCodes
    }] = _ref4;
    (0, _forEach.default)(_context5 = (0, _filter.default)(_context6 = (0, _entries.default)(postCodes)).call(_context6, notTotalEntry)).call(_context5, _ref5 => {
      var _context7;
      var [postCode, {
        total
      }] = _ref5;
      acc.push({
        name: (0, _concat.default)(_context7 = "".concat((0, _string.unSlug)(name.toLowerCase(), {
          recase: true
        }), " ")).call(_context7, postCode),
        total
      });
    });
    return acc;
  }, []);
  return (0, _sort.default)(extracted).call(extracted, (a, b) => b.total - a.total);
};

// Sorts property types by label
var fieldSort = field => (a, b) => {
  if (a[field] === b[field]) return 0;
  return a[field] < b[field] ? 1 : -1;
};
var labelSort = fieldSort('label');
var nameSort = fieldSort('name');
var totalSort = fieldSort('total');

// Merges b's data onto a
var combineCategories = (prioritised, a, b) => {
  var _context8, _context9;
  a.total += b.total;
  var types = (0, _sort.default)(_context8 = [...a.types, ...b.types]).call(_context8, labelSort);

  // Merge duplicates
  var deduped = (0, _reduce.default)(_context9 = (0, _slice.default)(types).call(types, 1)).call(_context9, (res, type) => {
    var last = res[res.length - 1];
    if (last.label === type.label) {
      var _context10, _context11, _context12, _context13;
      last.total += type.total;
      var suburbs = (0, _sort.default)(_context10 = (0, _map.default)(_context11 = [...last.suburbs, ...type.suburbs]
      // Copy suburbs to allow modification
      ).call(_context11, suburb => ({
        ...suburb
      }))).call(_context10, nameSort);
      last.suburbs = (0, _sort.default)(_context12 = (0, _reduce.default)(_context13 = (0, _slice.default)(suburbs).call(suburbs, 1)).call(_context13, (_res, suburb) => {
        var _last = _res[_res.length - 1];
        if (_last.name === suburb.name) {
          _last.total += suburb.total;
        } else {
          _res.push(suburb);
        }
        return _res;
      }, (0, _slice.default)(suburbs).call(suburbs, 0, 1))).call(_context12, totalSort);
    } else {
      res.push(type);
    }
    return res;
  }, (0, _slice.default)(types).call(types, 0, 1));
  a.types = (0, _sort.default)(deduped).call(deduped, sortPrioritisedType(prioritised));
};

// Sort property types appropriately
// Merge categories together
var merge = function (prioritised, categories) {
  var _context14, _context16;
  var typeKeys = (0, _reduce.default)(_context14 = (0, _map.default)(categories).call(categories, _ref6 => {
    var {
      typeKey
    } = _ref6;
    return typeKey;
  })).call(_context14, (res, key, index) => {
    res[key] = res[key] || [];
    res[key].push(index);
    return res;
  }, {});
  for (var _len = arguments.length, keys = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    keys[_key - 2] = arguments[_key];
  }
  var data = (0, _reduce.default)(keys).call(keys, (acc, key) => {
    var _context15;
    if (!typeKeys[key]) return acc;
    acc.push(...(0, _map.default)(_context15 = typeKeys[key]).call(_context15, idx => categories[idx]));
    return acc;
  }, []);

  // Group by category code, can't merge mismatched categories
  var grouped = (0, _reduce.default)(data).call(data, (acc, cat) => {
    var {
      categoryCode = ''
    } = cat;
    acc[categoryCode] = acc[categoryCode] || [];
    var group = acc[categoryCode];
    group.push(cat);
    return acc;
  }, {});
  (0, _forEach.default)(_context16 = (0, _values.default)(grouped)).call(_context16, _data => {
    var [into, ...rest] = _data;

    // Need at least two to merge together
    if (!rest.length) return;

    // Needed for flow
    if (typeof into !== 'object') return;
    (0, _forEach.default)(rest).call(rest, cat => {
      // Needed for flow
      if (typeof cat !== 'object') return;
      // Remove it from the list
      (0, _splice.default)(categories).call(categories, (0, _indexOf.default)(categories).call(categories, cat), 1);
      combineCategories(prioritised, into, cat);
    });
  });
};

// Split one category into multiple others, e.g. for BOTH, combining the values
// with any existing entries
var split = function (prioritised, categories, from) {
  var _context17, _context18, _context22, _context23;
  for (var _len2 = arguments.length, keys = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
    keys[_key2 - 3] = arguments[_key2];
  }
  var typeKeys = (0, _reduce.default)(_context17 = (0, _map.default)(categories).call(categories, _ref7 => {
    var {
      typeKey
    } = _ref7;
    return typeKey;
  })).call(_context17, (res, key, index) => {
    res[key] = res[key] || [];
    res[key].push(index);
    return res;
  }, {});

  // Nothing to split
  if (!typeKeys[from]) return;

  // The one that's being split
  (0, _forEach.default)(_context18 = typeKeys[from]).call(_context18, idx => {
    var _context19;
    var both = categories[idx];
    var map = {
      SLD: 'SAL',
      LSE: 'LSE'
    };
    var bothTypes = (0, _map.default)(_context19 = both.types).call(_context19, type => ({
      ...type,
      subTypeCode: map[type.statusCode] || type.subTypeCode
    }));

    // Current BOTH subtypes within type also need to be split out
    if (both.subTypeCode === 'BOTH') {
      var current = (0, _filter.default)(bothTypes).call(bothTypes, _ref8 => {
        var {
          statusCode
        } = _ref8;
        return statusCode === 'CUR';
      })[0];
      if (current) {
        // Drop out the current item
        (0, _splice.default)(bothTypes).call(bothTypes, (0, _indexOf.default)(bothTypes).call(bothTypes, current), 1);
        (0, _forEach.default)(keys).call(keys, key => {
          var typeCode = (0, _slice.default)(key).call(key, 0, 3);
          var subTypeCode = (0, _slice.default)(key).call(key, 3);

          // And push in the split types
          bothTypes.push({
            ...current,
            label: formatLabel(current.statusCode, typeCode, subTypeCode),
            typeCode,
            subTypeCode
          });
        });
      }
    }
    (0, _forEach.default)(keys).call(keys, key => {
      var _context20;
      var typeCode = (0, _slice.default)(key).call(key, 0, 3);
      var subTypeCode = (0, _slice.default)(key).call(key, 3);
      var types = (0, _map.default)(_context20 = (0, _filter.default)(bothTypes).call(bothTypes, type => type.subTypeCode === subTypeCode)).call(_context20, type => ({
        ...type,
        label: formatLabel(type.statusCode, typeCode, subTypeCode),
        typeCode,
        subTypeCode
      }));

      // Merge values in if the target is already there
      if (typeKeys[key] !== undefined) {
        var _context21;
        (0, _forEach.default)(_context21 = typeKeys[key]).call(_context21, _idx => {
          var cat = categories[_idx];
          if (cat.categoryCode !== both.categoryCode) return;
          combineCategories(prioritised, cat, {
            ...both,
            types
          });
        });
        return;
      }

      // Otherwise add it in in place of the target
      categories.push({
        ...both,
        typeKey: key,
        types,
        typeCode,
        subTypeCode
      });
    });
  });

  // Remove the "both" entries largest to smallest to avoid changing index order
  (0, _forEach.default)(_context22 = (0, _sort.default)(_context23 = typeKeys[from]).call(_context23, (a, b) => b - a)).call(_context22, idx => {
    (0, _splice.default)(categories).call(categories, idx, 1);
  });
};

// Munge types to a useable structure
// TODO: Stop relying on side effects in other functions
var buildSearchCategories = function (meta) {
  var _context24, _context25, _context34;
  var expandCategories = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var priorities = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var prioritised = (0, _reduce.default)(priorities).call(priorities, (acc, typeKey) => ({
    ...acc,
    [typeKey]: true
  }), {});
  var sortType = sortPrioritisedType(prioritised);
  var categories = (0, _reduce.default)(_context24 = (0, _filter.default)(_context25 = (0, _entries.default)(meta)).call(_context25, notTotalEntry)).call(_context24, (_cats, _ref9) => {
    var [typeKey, data] = _ref9;
    var typeCode = (0, _slice.default)(typeKey).call(typeKey, 0, 3);
    var subTypeCode = (0, _slice.default)(typeKey).call(typeKey, 3);
    if ((0, _indexOf.default)(expandCategories).call(expandCategories, typeCode) !== -1) {
      var _context26, _context27, _context28, _context29;
      // each category code = cat
      // each status code / category code = type
      // build total set of status / category combinations, then merge
      var set = (0, _reduce.default)(_context26 = (0, _filter.default)(_context27 = (0, _entries.default)(data.statusCode)).call(_context27, notTotalEntry)).call(_context26, (acc, _ref10) => {
        var [statusCode, {
          categories: _categories
        }] = _ref10;
        (0, _forEach.default)(_categories).call(_categories, _ref11 => {
          var {
            code,
            name,
            suburb,
            total
          } = _ref11;
          acc[code] = acc[code] || {
            label: name,
            typeKey,
            typeCode,
            subTypeCode,
            categoryCode: code,
            types: [],
            total: 0
          };
          var cat = acc[code];
          cat.total += total;
          cat.types.push({
            label: formatLabel(statusCode, typeCode, subTypeCode),
            typeKey,
            typeCode,
            subTypeCode,
            statusCode,
            categoryCode: code,
            suburbs: extractSuburbs(suburb),
            total
          });
        });
        return acc;
      }, {});
      var cats = (0, _map.default)(_context28 = (0, _sort.default)(_context29 = (0, _values.default)(set)).call(_context29, (a, b) => b.total - a.total)).call(_context28, cat => {
        var _context30;
        (0, _sort.default)(_context30 = cat.types).call(_context30, sortType);
        return cat;
      });
      _cats.push(...cats);
    } else {
      var _context31, _context32, _context33;
      // each type code = cat
      // each status code = type within cat
      var types = (0, _sort.default)(_context31 = (0, _map.default)(_context32 = (0, _filter.default)(_context33 = (0, _entries.default)(data.statusCode)).call(_context33, notTotalEntry)).call(_context32, _ref12 => {
        var [statusCode, {
          suburb,
          total
        }] = _ref12;
        return {
          label: formatLabel(statusCode, typeCode, subTypeCode),
          typeKey,
          typeCode,
          subTypeCode,
          statusCode,
          suburbs: extractSuburbs(suburb),
          total
        };
      })).call(_context31, sortType);
      _cats.push({
        label: (0, _codes.describeType)(typeCode, false),
        types,
        typeKey,
        typeCode,
        subTypeCode,
        total: data.total
      });
    }
    return _cats;
  }, []);
  split(prioritised, categories, 'COMBOTH', 'COMSAL', 'COMLSE');
  split(prioritised, categories, 'CLDBOTH', 'CLDSAL', 'CLDLSE');
  merge(prioritised, categories, 'SAL', 'REN');
  merge(prioritised, categories, 'COM', 'COMSAL', 'COMLSE');

  // Amend top level prioritised for merged fields
  if (prioritised.REN) prioritised.SAL = true;
  if (prioritised.COMLSE) prioritised.COMSAL = true;
  return (0, _sort.default)(_context34 = (0, _map.default)(categories).call(categories, cat => {
    var _context35;
    return {
      ...cat,
      total: cat.types.length ? (0, _reduce.default)(_context35 = cat.types).call(_context35, (sum, _ref13) => {
        var {
          total
        } = _ref13;
        return sum + total;
      }, 0) : cat.total
    };
  })).call(_context34, (a, b) => {
    // Force prioritised options to the top
    if (prioritised[a.typeKey] && !prioritised[b.typeKey]) return -1;
    if (prioritised[b.typeKey] && !prioritised[a.typeKey]) return 1;
    return b.total - a.total;
  });
};
exports.buildSearchCategories = buildSearchCategories;